import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import React = require("react");
import {Panel, PanelType, TextField} from "office-ui-fabric-react";
import {DmsSearch, DmsStorageType, TabType} from "../models";
import {DarkModeStyles} from "../utilities/DarkModeUtilities";

export interface PropertiesState extends ITeamsBaseComponentState {}

export interface PropertiesProps {
    showPropertiesPanel: boolean;
    darkMode: DarkModeStyles;
    ClosePanel: () => void;
    propertiesList: DmsSearch;
    storageType: string;
    tabType: TabType;
}

export class Properties extends TeamsBaseComponent<PropertiesProps, PropertiesState> {
    constructor(props: PropertiesProps) {
        super(props);
    }

    public render() {
        return (
            <Panel // panel for creating new document for a checked out file
                isOpen={this.props.showPropertiesPanel}
                className={this.props.darkMode.panelClassName}
                onDismiss={() => this.props.ClosePanel()}
                closeButtonAriaLabel="Close"
                customWidth="425px"
                type={PanelType.custom}
                headerText="Properties"
            >
                <hr style={{height: "10px", visibility: "hidden"}} />

                <div>
                    <TextField
                        className={this.props.darkMode.className}
                        readOnly={true}
                        multiline={false}
                        label={"File"}
                        style={{
                            backgroundColor: this.props.darkMode.backgroundColor,
                            color: this.props.darkMode.textColour,
                        }}
                        value={this.props.propertiesList.DocName}
                    />
                    <hr style={{height: "10px", visibility: "hidden"}} />

                    <TextField
                        className={this.props.darkMode.className}
                        readOnly={true}
                        multiline={false}
                        label={"ID"}
                        style={{
                            backgroundColor: this.props.darkMode.backgroundColor,
                            color: this.props.darkMode.textColour,
                        }}
                        value={this.props.propertiesList.Metadata["DocumentNumber"]}
                    />
                    <hr style={{height: "10px", visibility: "hidden"}} />

                    <TextField
                        className={this.props.darkMode.className}
                        readOnly={true}
                        multiline={false}
                        label={"Modified"}
                        style={{
                            backgroundColor: this.props.darkMode.backgroundColor,
                            color: this.props.darkMode.textColour,
                        }}
                        value={new Date(this.props.propertiesList.Metadata["Modified"]).toLocaleDateString()}
                    />
                    <hr style={{height: "10px", visibility: "hidden"}} />

                    <TextField
                        className={this.props.darkMode.className}
                        readOnly={false}
                        multiline={false}
                        label={"Modified By"}
                        style={{
                            backgroundColor: this.props.darkMode.backgroundColor,
                            color: this.props.darkMode.textColour,
                        }}
                        value={this.props.propertiesList.Metadata["ModifiedBy"]}
                    />
                    <hr style={{height: "10px", visibility: "hidden"}} />

                    {this.props.tabType == TabType.Dms && (
                        <TextField
                            className={this.props.darkMode.className}
                            readOnly={false}
                            multiline={false}
                            label={"Version"}
                            style={{
                                backgroundColor: this.props.darkMode.backgroundColor,
                                color: this.props.darkMode.textColour,
                            }}
                            value={this.props.propertiesList.Metadata["Version"]}
                        />
                    )}

                    {this.props.storageType == DmsStorageType.iManage && this.props.tabType == TabType.Dms && (
                        <div>
                            <hr style={{height: "10px", visibility: "hidden"}} />
                            <TextField
                                className={this.props.darkMode.className}
                                readOnly={false}
                                multiline={false}
                                label={"Class"}
                                style={{
                                    backgroundColor: this.props.darkMode.backgroundColor,
                                    color: this.props.darkMode.textColour,
                                }}
                                value={this.props.propertiesList.Metadata["Class"]}
                            />
                            <hr style={{height: "10px", visibility: "hidden"}} />

                            <TextField
                                className={this.props.darkMode.className}
                                readOnly={false}
                                multiline={false}
                                label={"Sub class"}
                                style={{
                                    backgroundColor: this.props.darkMode.backgroundColor,
                                    color: this.props.darkMode.textColour,
                                }}
                                value={this.props.propertiesList.Metadata["Subclass"]}
                            />
                        </div>
                    )}
                </div>
            </Panel>
        );
    }
}
